<template>
    <div >
        <v-row class="diagnostics">
            <label>Time: </label> {{ filterTimeFrom(entry.data.results.start) }} - {{ filterTimeTo(entry.data.results.end) }} ( {{entry.data.results.runtime}} ms )
        </v-row>
        <v-row class="diagnostics">
            <label>Diagnostic Type: </label> {{ entry.data.tool }}
        </v-row>
        <v-row class="diagnostics">
            <label>Location: </label> {{ entry.data.location }}
        </v-row>
        <v-row class="diagnostics">
            <label>Visibility: </label> {{ (entry.data.visibility === "public") ? "Public" : "Private" }}
        </v-row>

        <v-row class="diagnostics" v-if="entry.data.tool === 'browserperf'">
            <HarViewer :hardata="entry.data.results.message"  />
        </v-row>
        <v-row class="diagnostics" v-else-if="entry.data.tool === 'screenshot'">
            <img :src="screenshotSrc(entry.data.results.message)" :width="sizing.screenshotsize"  @click="showscreenshot = true" style="cursor: pointer" />
            <v-dialog v-model="showscreenshot">
                <v-card>
                    <v-card-title>Screenshot</v-card-title>
                    <v-card-text>
                        <div>
                            <v-btn text @click="showscreenshot = false" outlined dark color="primary">{{ sizing.closediag }}</v-btn>
                        </div>
                        <img :src="screenshotSrc(entry.data.results.message)"/>
                        <div>
                            <v-btn text @click="showscreenshot = false" outlined dark color="primary">{{ sizing.closediag }}</v-btn>
                        </div>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-row>
        <v-row class="diagnostics" v-else>
            <v-textarea :value="entry.data.results.message"  rows="2" auto-grow></v-textarea>
        </v-row>
    </div>
</template>

<script>
import {
    format as date_format,
    parse as date_parse,
    distanceInWordsStrict as date_distance
} from "date-fns";

import HarViewer from "./View_HarViewer";

export default {
    name: "EventsDiagnosticsView",
    data() {
        return {
            showscreenshot: false
        }
    },
    props: {
        entry: { type: Object }
    },
    components: { HarViewer },
    computed: {
        sizing: function () {
            let breakpoint = this.$vuetify.breakpoint;
            let screenshotsize = breakpoint.width * 0.64;
            return {
                breakpoint: breakpoint,
                screenshotsize: screenshotsize,
                opendiag: (breakpoint.name === "sm" || breakpoint.name === "xs") ? "Open" : "Show diagnostic info",
                closediag: (breakpoint.name === "sm" || breakpoint.name === "xs") ? "Close" : "Close"
            }
        }
    },
    methods: {
        screenshotSrc: function(val) {
            return 'data:image/png;base64,' + val;
        },
        filterTimeFrom: function(val) {
            return date_format(date_parse(val - 0), "MMM D HH:mm:ss");
        },
        filterTimeTo: function(val) {
            return date_format(date_parse(val - 0), "HH:mm:ss");
        }
    }
}

</script>
<style scoped>
.diagnostics {
    color: #333;
}
.diagnostics label {
    width: 200px;
    margin-right: 12px;
}
.diagnostics textarea { 
    font-family: monospace, monospace;
}
</style>